import React, { useState } from "react";
import MatchReport from "./MatchReport";
import MatchLineup from "./MatchLineup";
import MatchStats from "./MatchStats";
import "./style.css";

const MatchTabs = ({ match, playerStats, matchResults, cityName, leagueName }) => {
  const [activeTab, setActiveTab] = useState("report");

  return (
    <div className="tabs-container">
      <div className="tabs-buttons">
        <button
          className={activeTab === "report" ? "active" : ""}
          onClick={() => setActiveTab("report")}
        >
          Maç Raporu
        </button>
        <button
          className={activeTab === "lineup" ? "active" : ""}
          onClick={() => setActiveTab("lineup")}
        >
          Kadrolar
        </button>
        <button
          className={activeTab === "stats" ? "active" : ""}
          onClick={() => setActiveTab("stats")}
        >
          İstatistikler
        </button>
      </div>

      <div className="tabs-content">
        {activeTab === "report" && (
          <MatchReport match={match} playerStats={playerStats} cityName={cityName} leagueName={leagueName} />
        )}
        {activeTab === "lineup" && (
          <MatchLineup match={match} playerStats={playerStats} cityName={cityName} leagueName={leagueName} />
        )}
        {activeTab === "stats" && (
          <MatchStats match={match} playerStats={playerStats} matchResults={matchResults} />
        )}
      </div>
    </div>
  );
};

export default MatchTabs;
